import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Children, Fragment, memo, } from 'react';
import theme from '../../styles/theme';
import { getDisplayName } from './utils';
const optionGroupStyles = css `
  ${theme.typeStyles.captionSmallStyles}
  padding-bottom: ${theme.spacing.x3};
  padding-left: ${theme.spacing.x3};
  padding-right: ${theme.spacing.x3};
  padding-top: ${theme.spacing.x3};
`;
const SelectCustomOptionGroup = ({ breakBottom, breakTop, children, label, }) => (_jsxs(Fragment, { children: [breakTop && _jsx("hr", {}), _jsxs("div", Object.assign({ css: optionGroupStyles }, { children: [label, ":"] })), Children
            .toArray(children)
            .filter((child) => (getDisplayName(child) === 'SelectCustomOption')), breakBottom && _jsx("hr", {})] }));
const MemoizedSelectCustomOptionGroup = memo(SelectCustomOptionGroup);
MemoizedSelectCustomOptionGroup.displayName = 'SelectCustomOptionGroup';
export { MemoizedSelectCustomOptionGroup as SelectCustomOptionGroup };
// MC-1068 Temporary hack for Storybook.
export default MemoizedSelectCustomOptionGroup;
